import { parseJSON } from '@/shared/parse';
import { AuthService } from './AuthService';
import { TelemetryClientService } from './TelemetryClientService';
import { AppError } from '@/shared/AppError';

export class ApiService {

  public static async anonymousFetch<T>(path: string, method?: string, data?: any): Promise<T> {
    return await ApiService.fetchInternal<T>(path, method, data);
  }

  public static async fetch<T>(path: string, method?: string, data?: any): Promise<T> {
    const token = await AuthService.getAccessToken();
    return await ApiService.fetchInternal<T>(path, method, data, token);
  }

  public static async fetchInternal<T>(path: string, method?: string, data?: any, token?: string): Promise<T> {

    const options: any = {
      method: method ?? 'GET',
      headers: token ? {
        'Authorization': `Bearer ${token}`
      } : {},
      mode: 'cors',
      cache: 'default'
    };

    if (typeof data !== 'object' || (typeof data === 'object' && data instanceof FormData)) {
      options.body = data;
    } else {
      options.headers['Content-Type'] = 'application/json';
      options.body = data && JSON.stringify(data);
    }

    let response;
    try {
      response = await fetch(path, options);
    } catch (error) {
      TelemetryClientService.error(`API call failed ${path}`, error);
      throw new AppError(`Something went wrong`, {
        message: `Please check your internet connection and try again, or contact the support team if the problem persists.`
      });
    }

    if (response.ok) {
      const message: string = await response.text();
      if (response.headers.get('Content-Type')?.includes('application/json')) {
        return parseJSON(message);
      } else {
        return message as any;
      }
    } else {
      const message: string = await response.text();
      const parsed = parseJSON(message, {
        message: `Something went wrong`,
        internalError: {
          message: `Unexpected server response. Please try again, or contact the support team if the problem persists.`
        }
      });
      throw new AppError(parsed.message, parsed.internalError);
    }
  }

}